import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

export default {
  namespaced,
  state: {
    accounts: [],
    pagination: {},
    searchData: [],
    searchPagination: {},
    searchDataExist: null,
    pending: true,
    accountData: {}
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js